import type { NullableNumber } from '../types/account';

export const CANONICAL_LIVE_RETURN_WINDOWS = [
  { timeframe: 'return24h', marketplaceKey: 'day', label: '1D' },
  { timeframe: 'return30d', marketplaceKey: 'month', label: '1M' },
  { timeframe: 'return3mo', marketplaceKey: 'month3', label: '3M' },
  { timeframe: 'return6mo', marketplaceKey: 'month6', label: '6M' },
  { timeframe: 'return1y', marketplaceKey: 'year', label: '1Y' },
  { timeframe: 'returnAll', marketplaceKey: 'allTime', label: 'All' },
] as const;

export type CanonicalLiveReturnTimeframe =
  (typeof CANONICAL_LIVE_RETURN_WINDOWS)[number]['timeframe'];

type PerformanceStat = {
  timeframe?: string | null;
  stats?: {
    is_data_complete?: boolean | null;
    return?: NullableNumber;
    total_return?: NullableNumber;
  } | null;
};

export const normalizeLiveReturnPercentage = (value: NullableNumber): number | null => {
  if (value === null || value === undefined) return null;
  const normalized = String(value).replace('%', '').trim();
  if (!normalized) return null;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getCanonicalLiveReturnPercentage = (
  stats: PerformanceStat[] | null | undefined,
  timeframe: CanonicalLiveReturnTimeframe,
): number | null => {
  if (!Array.isArray(stats)) return null;
  const entry = stats.find((candidate) => candidate?.timeframe === timeframe);
  if (!entry?.stats || entry.stats.is_data_complete === false) return null;
  return normalizeLiveReturnPercentage(entry.stats.total_return ?? entry.stats.return);
};

export const formatLiveReturnPercentage = (value: NullableNumber, missingValue = '—'): string => {
  const numeric = normalizeLiveReturnPercentage(value);
  if (numeric === null) return missingValue;
  const rounded = numeric.toFixed(2);
  return `${Number(rounded) > 0 ? '+' : ''}${rounded}%`;
};
